export const DONE_LABELS = ["done", "complete", "completed", "finished"];

